import React, { useState, useMemo }  from 'react'
import { Container, Form, Button, Image, Row, Col, Nav, NavDropdown, Table } from 'react-bootstrap';
import { Search, Filter, Calendar, DollarSign, AlertTriangle, CheckCircle2, Clock, Target, TrendingUp, FileText } from 'lucide-react';
import SideNav from '../components/SideNav';
import StepProgress from '../components/StepProgress';
import OrdersPage from './OrderPage';
import ProjectList from '../components/ProjectList';
import NotificationDropdown from '../components/NotificationDropdown'; // New notification component
import './ReportProjectOverview.css'
import { useMyTask } from '../hooks/useMyTask'
import Filters from '../components/Filters';



function ReportProjectOverview() {
   const userUId = window.localStorage.getItem('projectUserUID');
  const userRole = window.localStorage.getItem('projectUserRole');


    const { isLoading, isError, error, data } = useMyTask(userUId, userRole);

    console.log("datetet", data);

    const [searchTerm, setSearchTerm] = useState('');
  const [selectedStage, setSelectedStage] = useState('');
  const [completionFilter, setCompletionFilter] = useState('');

  
    // const formatDate = (dateString) => {
    //   const options = { year: 'numeric', month: 'short', day: 'numeric' };
    //   return new Date(dateString).toLocaleDateString(undefined, options);
    // };
 


  // const projectData = [
  //   {
  //     id: 1,
  //     projectName: 'Project One',
  //     stage: 'Development',
  //     percentComplete: 65,
  //     closedTasks: 13,
  //     openTasks: 7,
  //     plannedStart: '2024-01-15',
  //     plannedFinish: '2024-04-30',
  //     actualStartDate: '2024-01-18',
  //     tentativeFinish: '2024-05-05',
  //     deviation: 5,
  //     tentative40Collection: '2024-02-20',
  //     amount40: 25000
  //   },
  //   {
  //     id: 2,
  //     projectName: 'Project Two',
  //     stage: 'Testing',
  //     percentComplete: 85,
  //     closedTasks: 17,
  //     openTasks: 3,
  //     plannedStart: '2024-02-01',
  //     plannedFinish: '2024-05-15',
  //     actualStartDate: '2024-02-01',
  //     tentativeFinish: '2024-05-10',
  //     deviation: -5,
  //     tentative40Collection: '2024-03-15',
  //     amount40: 35000
  //   },
  //   {
  //     id: 3,
  //     projectName: 'Project Three',
  //     stage: 'Planning',
  //     percentComplete: 25,
  //     closedTasks: 5,
  //     openTasks: 15,
  //     plannedStart: '2024-03-01',
  //     plannedFinish: '2024-07-30',
  //     actualStartDate: '2024-03-05',
  //     tentativeFinish: '2024-08-15',
  //     deviation: 16,
  //     tentative40Collection: '2024-04-10',
  //     amount40: 18000
  //   },
  //   {
  //     id: 4,
  //     projectName: 'Project Four',
  //     stage: 'Deployment',
  //     percentComplete: 95,
  //     closedTasks: 19,
  //     openTasks: 1,
  //     plannedStart: '2024-01-10',
  //     plannedFinish: '2024-03-30',
  //     actualStartDate: '2024-01-10',
  //     tentativeFinish: '2024-04-02',
  //     deviation: 3,
  //     tentative40Collection: '2024-02-05',
  //     amount40: 42000
  //   }
  // ];

  // const filteredData = useMemo(() => {
  //   return data.filter(project => {
  //     const matchesSearch = project.projectName.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //                          project.projectStatus.toLowerCase().includes(searchTerm.toLowerCase());
      
  //     const matchesStage = selectedStage === '' || project.projectStatus === selectedStage;
      
  //     const matchesCompletion = completionFilter === '' || 
  //                              (completionFilter === 'low' && project.completedStagePercentage < 30) ||
  //                              (completionFilter === 'medium' && project.completedStagePercentage >= 30 && project.completedStagePercentage < 70) ||
  //                              (completionFilter === 'high' && project.completedStagePercentage >= 70);
      
  //     return matchesSearch && matchesStage && matchesCompletion;
  //   });
  // }, [projectData, searchTerm, selectedStage, completionFilter]);

  const getProgressColor = (completion) => {
    if (completion < 30) return 'bg-red-500';
    if (completion < 70) return 'bg-yellow-500';
    return 'bg-green-500';
  };

  const getStageBadgeColor = (stage) => {
    const colors = {
      'sales-phase': 'bg-blue-100 text-blue-800',
      'design-phase': 'bg-purple-100 text-purple-800',
      'Testing': 'bg-orange-100 text-orange-800',
      'Deployment': 'bg-green-100 text-green-800'
    };
    return colors[stage] || 'bg-gray-100 text-gray-800';
  };

  // const getDeviationColor = (deviation) => {
  //   if (deviation > 10) return 'text-red-600 bg-red-50';
  //   if (deviation > 0) return 'text-yellow-600 bg-yellow-50';
  //   return 'text-green-600 bg-green-50';
  // };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric',
      year: 'numeric'
    });
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0
    }).format(amount);
  };

  // const uniqueStages = [...new Set(data.map(p => p.projectStatus))];
  // const totalAmount = data.reduce((sum, p) => sum + p.amount40, 0);
  // const totalTasks = data.reduce((sum, p) => sum + p.closedTasks + p.openTasks, 0);
  // const avgCompletion = Math.round(data.reduce((sum, p) => sum + p.percentComplete, 0) / data.length);

//  const projects = [
//     {
//       name: "E-Commerce Platform",
//       stage: "Development",
//       completion: 65,
//       tasks: "24/36",
//       plannedDates: "Jan 15 - May 30",
//       actualStart: "Jan 18, 2025",
//       tentativeFinish: "Jun 15, 2025",
//       deviation: "+16 days",
//       collection: "$48,000",
//       amount: "$120,000"
//     },
//     {
//       name: "Mobile App Redesign",
//       stage: "Testing",
//       completion: 85,
//       tasks: "17/20",
//       plannedDates: "Feb 01 - Apr 15",
//       actualStart: "Feb 03, 2025",
//       tentativeFinish: "Apr 10, 2025",
//       deviation: "-5 days",
//       collection: "$28,000",
//       amount: "$70,000"
//     },
//     {
//       name: "Customer Portal",
//       stage: "Planning",
//       completion: 15,
//       tasks: "3/25",
//       plannedDates: "Mar 01 - Jul 30",
//       actualStart: "Mar 05, 2025",
//       tentativeFinish: "Aug 05, 2025",
//       deviation: "+6 days",
//       collection: "$36,000",
//       amount: "$90,000"
//     },
//     {
//       name: "Analytics Dashboard",
//       stage: "Deployment",
//       completion: 95,
//       tasks: "19/20",
//       plannedDates: "Dec 01 - Mar 15",
//       actualStart: "Dec 03, 2024",
//       tentativeFinish: "Mar 12, 2025",
//       deviation: "-3 days",
//       collection: "$20,000",
//       amount: "$50,000"
//     },
//     {
//       name: "API Integration Suite",
//       stage: "Development",
//       completion: 45,
//       tasks: "12/28",
//       plannedDates: "Apr 01 - Aug 15",
//       actualStart: "Apr 01, 2025",
//       tentativeFinish: "Aug 20, 2025",
//       deviation: "+5 days",
//       collection: "$32,000",
//       amount: "$80,000"
//     },
//      {
//       name: "API Integration Suite",
//       stage: "Development",
//       completion: 45,
//       tasks: "12/28",
//       plannedDates: "Apr 01 - Aug 15",
//       actualStart: "Apr 01, 2025",
//       tentativeFinish: "Aug 20, 2025",
//       deviation: "+5 days",
//       collection: "$32,000",
//       amount: "$80,000"
//     }
//   ];

  const getStageColor = (stage) => {
    switch (stage) {
      case 'sales-phase': return 'bg-yellow-100 text-yellow-800';
      case 'Development': return 'bg-blue-100 text-blue-800';
      case 'design-phase': return 'bg-purple-100 text-purple-800';
      case 'Deployment': return 'bg-green-100 text-green-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  const getDeviationColor = (deviation) => {
    if (deviation.startsWith('+')) return 'text-red-600';
    if (deviation.startsWith('-')) return 'text-green-600';
    return 'text-gray-600';
  };


    const getStageVariant = (stage) => {
    switch (stage) {
      case 'sales-phase': return 'warning';
      case 'design-phase': return 'primary';
      // case 'design-phase': return 'info';
      case 'production-phase': return 'success';
      default: return 'secondary';
    }
  };

  const getDeviationClass = (deviation) => {
    if (deviation.startsWith('+')) return 'text-danger fw-bold';
    if (deviation.startsWith('-')) return 'text-success fw-bold';
    return 'text-muted';
  };
   // Custom CSS styles
  const tableStyles = {
    container: {
      overflowX: 'auto',
      maxHeight: '73.2vh',
      border: '1px solid #dee2e6',
      borderRadius: '0.375rem',
      backgroundColor: 'white',
      padding: 0
    },
    table: {
      marginBottom: 0,
      // minWidth: '1000px'
    },
    stickyCell: {
      position: 'sticky',
      left: 0,
      backgroundColor: '#f8f9fa',
      boxShadow: '1px 0 0 #dee2e6',
      zIndex: 1
    },
    stickyHeader: {
      position: 'sticky',
      left: 0,
      backgroundColor: '#f8f9fa',
      boxShadow: '1px 0 0 #dee2e6',
      zIndex: 2
    },
    progressContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px'
    },
    progressBar: {
      height: '8px',
      backgroundColor: '#e9ecef',
      borderRadius: '4px',
      overflow: 'hidden',
      flex: 1
    },
    progressFill: {
      height: '100%',
      background: 'linear-gradient(90deg, #0d6efd, #20c997)',
      transition: 'width 0.3s ease'
    }
  };

   
    // if (isLoading) {
    //   return <div>Loading...</div>;
    // }
  
    if (isError) {
      return <div>Error: {error}</div>;
    }

  return (
      <Container fluid className='p-3' style={{ backgroundColor: "#F9FAFB", height: "100vh", }}>
            <Row>
                <Col className='col-auto'>
                   <SideNav />
                </Col>
                <Col style={{ padding: "0px 10px 0px 20px",flexGrow:1}}>
                    <Row className='p-2' style={{ backgroundColor: "#fff", borderRadius: '10px', alignItems: "center", justifyContent: "spaceBetween" }}>
                        <Col><h4 style={{ color: "#000" }}>Projects Overview</h4></Col>
                        <Col className="d-flex justify-content-end align-items-center">
                        {/* <Notific/ationDropdown userId={userUId} /> */}
                            {/* <Image src={require('../assets/notification.png')} roundedCircle style={{ width: '25px', height: 'auto', marginRight: '5px', }} /> */}
                            <Image src={require('../assets/user.jpg')} roundedCircle style={{ width: '40px', height: 'auto' }} />
                        </Col>
                    </Row>
                    <Row className='p-2 mt-2' style={{  borderRadius: '10px', alignItems: "center", justifyContent: "spaceBetween" }}>
                       
                            {/* Filters */}
        <Filters  selectedStage={selectedStage} setSelectedStage={setSelectedStage} completionFilter={completionFilter} setCompletionFilter={setCompletionFilter}   />

                 <div style={tableStyles.container}>
          <table className="table table-hover" style={tableStyles.table}>
            <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 5, backgroundColor: '#f8f9fa' }}>
              <tr>
                <th 
                  className="px-3 py-3 text-start text-uppercase small fw-semibold"
                  style={tableStyles.stickyHeader}
                >
                  Project Name
                </th>
                <th className="px-3 py-3 text-start text-uppercase small fw-semibold">
                  Stage
                </th>
                <th className="px-3 py-3 text-start text-uppercase small fw-semibold">
                  % Complete
                </th>
                <th className="px-3 py-3 text-start text-uppercase small fw-semibold">
                  Booking Date
                </th>
                <th className="px-3 py-3 text-start text-uppercase small fw-semibold">
                  BOQ Value (exc GST)
                </th>
                <th className="px-3 py-3 text-start text-uppercase small fw-semibold">
                  Target KT Date
                </th>
                <th className="px-3 py-3 text-start text-uppercase small fw-semibold">
                  Actual KT Date
                </th>
                <th className="px-3 py-3 text-start text-uppercase small fw-semibold">
                  Status
                </th>
                 <th className="px-3 py-3 text-start text-uppercase small fw-semibold">
                  Vriance
                </th>
                <th className="px-3 py-3 text-start text-uppercase small fw-semibold">
                  Current Tasks Name
                </th>
                <th className="px-3 py-3 text-start text-uppercase small fw-semibold">
                  Target Push To Production Date
                </th>
                <th className="px-3 py-3 text-start text-uppercase small fw-semibold">
                  Actual Push To Production Date
                </th>
                <th className="px-3 py-3 text-start text-uppercase small fw-semibold">
                  Status
                </th>
                <th className="px-3 py-3 text-start text-uppercase small fw-semibold">
                  Variance
                </th>
                {/* <th className="px-3 py-3 text-start text-uppercase small fw-semibold">
                  40% Collection Date
                </th> */}
                 <th className="px-3 py-3 text-start text-uppercase small fw-semibold">
                 Execution Stage
                </th>
                <th className="px-3 py-3 text-start text-uppercase small fw-semibold">
                  Target Handover Date
                </th>
                <th className="px-3 py-3 text-start text-uppercase small fw-semibold">
                 Actual Handover Date
                </th>
                <th className="px-3 py-3 text-start text-uppercase small fw-semibold">
                  Status
                </th>
                <th className="px-3 py-3 text-start text-uppercase small fw-semibold">
                  Vriance
                </th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? <div> Loading....</div> : data.map((project, index) => (
                <tr key={index}>
                  <td 
                    className="px-3 py-3 fw-semibold text-dark"
                    style={tableStyles.stickyCell}
                  >
                    {project.projectName}
                  </td>
                  <td className="px-3 py-3">
                    <span className={`badge bg-${getStageVariant(project.projectStatus)}`}>
                      {project.projectStatus}
                    </span>
                  </td>
                  <td className="px-3 py-3">
                    <div style={tableStyles.progressContainer}>
                      <div style={tableStyles.progressBar}>
                        <div 
                          style={{
                            ...tableStyles.progressFill,
                            width: `${project.completedStagePercentage}%`
                          }}
                        />
                      </div>
                      <small className="text-muted">{project.completedStagePercentage}%</small>
                    </div>
                  </td>
                  <td className="px-3 py-3">{project.closureDate}</td>
                  {/* <td className="px-3 py-3">{project.plannedStart ? formatDate(project.plannedStart) `<br/>` + formatDate(project.plannedFinish) : null}</td> */}
                  {/* <td className="px-3 py-3">{project.plannedFinish? formatDate(project.plannedFinish) : null}</td> */}
                  {/* <td className="px-3 py-3">{project.plannedFinish? formatDate(project.plannedFinish) : null}</td> */}
                  {/* <td className={`px-3 py-3 ${project.updatedDuration ? getDeviationClass(project.updatedDuration) : null}`}> */}
                  <td className={`px-3 py-3 `}>
                  {/* <td className={`px-3 py-3`}> */}
                    {project.updatedDuration}
                  </td>
                  <td className="px-3 py-3">{project.collectionDate ? formatDate(project.collectionDate) : null}</td>
                  <td className="px-3 py-3 fw-bold">12</td>
                  <td className="px-3 py-3 fw-bold">13</td>
                  <td className="px-3 py-3 fw-bold">14</td>
                  <td className="px-3 py-3 fw-bold">15</td>
                  <td className="px-3 py-3 fw-bold">16</td>
                  <td className="px-3 py-3 fw-bold">17</td>
                  <td className="px-3 py-3 fw-bold">18</td>
                  <td className="px-3 py-3 fw-bold">19</td>
                  <td className="px-3 py-3 fw-bold">20</td>
                  <td className="px-3 py-3 fw-bold">21</td>
                  <td className="px-3 py-3 fw-bold">22</td>
                  <td className="px-3 py-3 fw-bold">23</td>
                  <td className="px-3 py-3 fw-bold">24</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
                      
                    </Row>

                </Col>
            </Row>
        </Container>
  )
}

export default ReportProjectOverview